import { useI18n } from '../../contexts/I18nContext';
import { Shield, Building2, Users, TrendingUp, Award, Target, Briefcase, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';

// Team member photos
const TEAM_PHOTOS = {
  fernando: 'https://customer-assets.emergentagent.com/job_79b1230d-349d-4e3f-a2d7-9f6948366d30/artifacts/iezwaqs2_WhatsApp%20Image%202026-04-09%20at%203.32.28%20PM.jpeg',
  jorge: 'https://customer-assets.emergentagent.com/job_79b1230d-349d-4e3f-a2d7-9f6948366d30/artifacts/g91yd663_WhatsApp%20Image%202026-04-09%20at%203.29.43%20PM%20%282%29.jpeg',
  antonio: 'https://customer-assets.emergentagent.com/job_79b1230d-349d-4e3f-a2d7-9f6948366d30/artifacts/csbtf81l_WhatsApp%20Image%202026-04-09%20at%203.37.33%20PM.jpeg'
};

const EquipoPage = () => {
  const { t } = useI18n();

  const teamDirectivo = [
    {
      name: 'Fernando Madrid',
      role: 'Chief Executive Officer (CEO)',
      company: 'SilverBrick Development',
      photo: TEAM_PHOTOS.fernando,
      bio: `Fernando Madrid cuenta con una trayectoria enfocada en la estructuración de inversión y desarrollo inmobiliario, con especialización en la identificación, análisis y ejecución de oportunidades dentro del sector real estate.

A lo largo de su carrera ha participado en la estructuración y desarrollo de proyectos inmobiliarios, así como en la obtención de capital para su ejecución, integrando procesos de originación, análisis financiero y diseño de vehículos de inversión.

Su experiencia abarca activos inmobiliarios urbanos, destacando por su capacidad para identificar oportunidades de valor, estructurar esquemas eficientes de financiamiento y ejecutar estrategias orientadas a maximizar rentabilidad bajo un enfoque disciplinado de control de riesgo.

Dentro de SilverBrick, lidera la originación de oportunidades, la estructuración de inversiones y la coordinación estratégica de proyectos, asegurando la alineación entre ejecución operativa y objetivos financieros.

Su principal aportación al fondo radica en la generación de pipeline de inversión, la estructuración eficiente de proyectos y la ejecución con disciplina financiera, contribuyendo a la creación de valor sostenido para los inversionistas.

Su enfoque profesional se basa en la identificación de oportunidades con alto potencial, ejecución eficiente y gestión rigurosa del riesgo, alineando cada proyecto con una visión de crecimiento sólido y de largo plazo.`,
      highlights: [
        { icon: Target, text: 'Originación de Oportunidades' },
        { icon: Briefcase, text: 'Estructuración de Inversiones' },
        { icon: TrendingUp, text: 'Control de Riesgo' }
      ]
    },
    {
      name: 'Gabriel Antonio Lascurain',
      role: 'Chief Commercial Officer (CCO)',
      company: 'SilverBrick Development',
      photo: TEAM_PHOTOS.antonio,
      bio: `Licenciado en Contaduría por la Universidad Simón Bolívar, con estudios de posgrado en la Universidad Pontificia Comillas de Madrid.

Cuenta con más de 25 años de experiencia en dirección empresarial, desarrollo comercial y expansión de negocios, participando en la consolidación y crecimiento de diversas organizaciones.

Es gestor certificado de riesgos y especialista en planeación estratégica, con una sólida trayectoria en la estructuración de modelos comerciales eficientes y sostenibles.

Dentro de SilverBrick, lidera la estrategia comercial del fondo, enfocándose en la expansión, posicionamiento y consolidación de oportunidades, así como en el fortalecimiento de relaciones estratégicas clave.

Su experiencia permite estructurar estrategias comerciales alineadas con los objetivos del fondo, impulsando el crecimiento y la captación de oportunidades bajo un enfoque estratégico y de gestión de riesgo.`,
      highlights: [
        { icon: Award, text: '25+ Años de Experiencia' },
        { icon: Shield, text: 'Gestor Certificado de Riesgos' },
        { icon: Target, text: 'Estrategia Comercial' }
      ]
    },
    {
      name: 'Jorge Esteban Salcido Toledo',
      role: 'Presidente del Consejo',
      company: 'SilverBrick Development',
      photo: TEAM_PHOTOS.jorge,
      bio: `Ingeniero Industrial por la Universidad Iberoamericana, con formación especializada en negocios e inversiones inmobiliarias a través de múltiples diplomados y certificaciones de la Asociación Mexicana de Profesionales Inmobiliarios (AMPI), así como certificación federal en comercialización inmobiliaria.

Cuenta con una trayectoria sólida en el sector inmobiliario, desarrollo de negocios y estructuración de proyectos, destacando por su participación en la dirección, comercialización y expansión de iniciativas dentro del sector real estate.

Es socio fundador y Presidente Nacional de la Unión de Profesionales Inmobiliarios de México (UPIM), organización que ha impulsado la profesionalización del sector a nivel nacional y que actualmente cuenta con presencia en distintas regiones del país, consolidando una red estratégica dentro de la industria inmobiliaria.

Asimismo, se desempeña como Director Ejecutivo de la desarrolladora "Échale Tu Casa", una de las vivienderas sociales más relevantes en México, con más de 40 años de trayectoria y más de 250,000 soluciones de vivienda desarrolladas en el país, enfocada en la construcción de vivienda digna y sostenible.

Su perfil combina visión estratégica, liderazgo institucional y conocimiento profundo del sector inmobiliario, aportando al fondo una dirección sólida en términos de estructura, crecimiento y posicionamiento.

Como Presidente del Consejo, su función se centra en la definición de la visión estratégica del fondo, la supervisión de su ejecución y la alineación de los intereses de los inversionistas con la operación del vehículo de inversión.

Su enfoque se basa en el desarrollo de estructuras institucionales sólidas, la generación de alianzas estratégicas y la consolidación de plataformas inmobiliarias con capacidad de escalar a nivel nacional.`,
      highlights: [
        { icon: Award, text: 'Presidente Nacional UPIM' },
        { icon: Building2, text: 'Director Échale Tu Casa' },
        { icon: FileText, text: 'Certificación AMPI' }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background pt-20">
      {/* Hero Section */}
      <section className="section-spacing border-b border-border">
        <div className="container-app">
          <div className="max-w-4xl mx-auto text-center">
            <p className="caption mb-4">Equipo Directivo y Consejo Estratégico</p>
            <h1 className="heading-1 mb-6">Un equipo con visión, ejecución y experiencia institucional</h1>
            <p className="body-lg text-muted-foreground">
              En SilverBrick Development, la fortaleza del fondo radica en la experiencia, visión estratégica 
              y capacidad de ejecución de su equipo directivo y consejo.
            </p>
            <p className="body-lg text-muted-foreground mt-4">
              Cada uno de sus integrantes aporta un enfoque especializado en estructuración de inversión, 
              desarrollo inmobiliario, gestión de riesgo y expansión comercial, consolidando una plataforma 
              sólida orientada a la generación de valor sostenible para sus inversionistas.
            </p>
          </div>
        </div>
      </section>

      {/* Team Members */}
      <section className="section-spacing">
        <div className="container-app">
          <div className="space-y-32">
            {teamDirectivo.map((member, index) => (
              <div 
                key={index} 
                className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start`}
              >
                {/* Photo - alternating sides */}
                <div className={`lg:col-span-5 ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <div className="relative max-w-md mx-auto lg:mx-0">
                    <div className="aspect-[3/4] overflow-hidden rounded-lg shadow-2xl">
                      <img 
                        src={member.photo} 
                        alt={member.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    {/* Decorative element */}
                    <div className="absolute -bottom-6 -right-6 w-full h-full border-2 border-primary/30 rounded-lg -z-10" />
                    <div className="absolute -bottom-3 -right-3 w-full h-full bg-primary/5 rounded-lg -z-20" />
                  </div>
                </div>

                {/* Bio */}
                <div className={`lg:col-span-7 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <div className="space-y-6">
                    {/* Name and Role */}
                    <div>
                      <h2 className="text-3xl md:text-4xl font-light tracking-tight mb-2">
                        {member.name}
                      </h2>
                      <p className="text-primary font-medium tracking-wide uppercase text-sm mb-1">
                        {member.role}
                      </p>
                      <p className="text-muted-foreground text-sm">
                        {member.company}
                      </p>
                    </div>
                    
                    {/* Divider */}
                    <div className="w-20 h-px bg-primary/40" />
                    
                    {/* Bio text */}
                    <div className="space-y-4 text-muted-foreground leading-relaxed">
                      {member.bio.split('\n\n').map((paragraph, pIndex) => (
                        <p key={pIndex}>{paragraph}</p>
                      ))}
                    </div>

                    {/* Highlights */}
                    <div className="pt-4">
                      <div className="flex flex-wrap gap-3">
                        {member.highlights.map((highlight, hIndex) => {
                          const Icon = highlight.icon;
                          return (
                            <span 
                              key={hIndex}
                              className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 text-primary text-sm font-medium rounded-full"
                            >
                              <Icon className="h-4 w-4" strokeWidth={1.5} />
                              {highlight.text}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Track Record */}
      <section className="section-spacing bg-muted/30 border-t border-border">
        <div className="container-app">
          <div className="text-center mb-12">
            <p className="caption mb-4">Trayectoria Comprobada</p>
            <h2 className="heading-2">Resultados que Respaldan Nuestra Experiencia</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div className="p-6">
              <p className="text-5xl md:text-6xl font-light text-primary mb-2">+50</p>
              <p className="text-sm text-muted-foreground">Proyectos Completados</p>
            </div>
            <div className="p-6">
              <p className="text-5xl md:text-6xl font-light text-primary mb-2">+500K</p>
              <p className="text-sm text-muted-foreground">m² Desarrollados</p>
            </div>
            <div className="p-6">
              <p className="text-5xl md:text-6xl font-light text-primary mb-2">+250K</p>
              <p className="text-sm text-muted-foreground">Soluciones de Vivienda</p>
            </div>
            <div className="p-6">
              <p className="text-5xl md:text-6xl font-light text-primary mb-2">15+</p>
              <p className="text-sm text-muted-foreground">Años de Experiencia</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-spacing bg-primary text-primary-foreground">
        <div className="container-app text-center">
          <h2 className="heading-2 mb-6">¿Listo para Invertir con Nosotros?</h2>
          <p className="body-lg text-primary-foreground/70 max-w-2xl mx-auto mb-8">
            Únase a nuestra red de inversionistas y acceda a oportunidades inmobiliarias de clase institucional 
            respaldadas por un equipo con experiencia comprobada.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/oportunidades">
              <Button className="bg-background text-foreground hover:bg-background/90 rounded-sm px-8 py-4 h-auto text-sm uppercase tracking-wide font-medium">
                Ver Oportunidades
              </Button>
            </Link>
            <Link to="/contacto">
              <Button variant="outline" className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10 rounded-sm px-8 py-4 h-auto text-sm uppercase tracking-wide font-medium">
                Contactar
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EquipoPage;
